import { Button, Alert as MuiAlert } from "@mui/material";
import { useResendActivationEmailMutation } from "generated.hooks";
import useAuth from "hooks/useAuth";
import React from "react";
import styled from "styled-components/macro";

const Alert = styled(MuiAlert)`
  border-radius: 0;
`;

const VerificationAlert = () => {
  const { user } = useAuth();
  const [resend, { loading }] = useResendActivationEmailMutation();

  return (
    <Alert severity="warning">
      We have sent an email to <b>{user.email}</b> to verify your account. if
      you did not receive it, click{" "}
      <Button
        variant="text"
        sx={{ minWidth: 0, p: 0.25 }}
        disabled={loading}
        onClick={() => {
          resend({ variables: { email: user.email } });
        }}
      >
        Resend
      </Button>
    </Alert>
  );
};

export default VerificationAlert;
